import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'
export const FacilitiesAwakening = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-awakening.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        By using Awaken/Reincarnate, you can <span className='text-pborange'>change a unit’s class</span> or <span className='text-pborange'>increase the Spirit (stat bonus)</span>. 
                    </p>{' '}<br/>
                    <p className='mt-4'>
                        Awakening is a unit-strengthening feature that allows you to <span className='text-pborange'>keep</span> a unit's current level and receive the corresponding amount of Spirit.
                    </p><br/>
                    <p>
                        It's a <span className='text-pborange'>great way</span> to keep the same class, race, and level while still powering that unit up. 
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'awakening',
                                index: 1,
                            },
                        ]}
                        description={"Use Spirit to add stat bonuses and strengthen your units!"}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        Reincarnation is a system where a character's class or race can change and they are reset to Level 1 while <span className='text-pborange'>retaining</span> their Skills, Abilities, and Title.
                    </p>{' '}<br/>
                    <p>
                        When Reincarnating, you will receive that character's current level worth of Spirit, which you can then distribute to their stats, so they will be much more powerful than a normal Level 1 unit. In addition, since they will keep the Skills and Abilities of their former class or race, they will be a <span className='text-pborange'>very unique</span> unit.
                    </p>{' '}<br/>
                    <p>
                        To use either Awakening or Reincarnation, very important items called "Changebooks" and "Eggs" are required, respectively.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'awakening',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="A Fighter who has Reincarnated into a Witch retains the Fighter's ability Wild Cry."
                    />{' '}
                </div>{' '}
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </>
    )
}
